module.exports = __webpack_public_path__ + "static/img/pay-10.ca9f1b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pay/pay-10.png
// module id = DGjP
// module chunks = 1